import { DataModel } from "common/models/utility-models/base-model";

export class FeedbackStudentModel extends DataModel {
    feedback_form_mapping_id: any = '';

}